import React from 'react';
import { BENEFITS, SALARY_DISCLAIMER, SALARY_FROM, SALARY_TO, WORK_REGIONS } from '../data/siteData';
import { useFormModal } from '../context/FormModalContext';

const ConditionsPage = () => {
    const { openForm } = useFormModal();

    return (
        <div className="page">
            <div className="container page-container">
                <h1 className="page-title">Условия работы</h1>

                <div className="page-content">
                    <h2>Заработная плата</h2>
                    <p>
                        Ориентировочный доход при полной вахте: от {SALARY_FROM.toLocaleString('ru-RU')} до{' '}
                        {SALARY_TO.toLocaleString('ru-RU')} рублей в месяц в зависимости от вакансии охраны и объекта.
                    </p>
                    <p>{SALARY_DISCLAIMER}</p>

                    <h2>График работы</h2>
                    <p>
                        Вахтовый метод: смены 15/15, 30/30 или иные варианты в зависимости от вакансии и
                        работодателя. Точный график оговаривается при консультации.
                    </p>

                    <h2>Регионы</h2>
                    <ul>
                        {WORK_REGIONS.map((region) => (
                            <li key={region}>{region}</li>
                        ))}
                    </ul>

                    <h2>Проживание и питание</h2>
                    <p>
                        Проживание в вахтовых условиях и организованное питание на период работы
                        предоставляются работодателем. Условия уточняются индивидуально.
                    </p>

                    <h2>Проезд и подъёмные</h2>
                    <p>
                        Проезд к месту работы оплачивается работодателем. Выплачиваются подъёмные при
                        трудоустройстве — размер и условия зависят от вакансии и региона.
                    </p>

                    <h2>Оформление</h2>
                    <p>
                        Трудоустройство осуществляется официально — по трудовому договору с работодателем.
                        Оформляются социальные гарантии, больничные и пенсионные отчисления в соответствии с
                        законодательством РФ.
                    </p>

                    <h2>Преимущества</h2>
                    <ul>
                        {BENEFITS.map(({ title, description }) => (
                            <li key={title}>
                                <strong>{title}</strong> — {description}
                            </li>
                        ))}
                    </ul>

                    <button type="button" className="cta-button" onClick={openForm}>
                        Подать заявку
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ConditionsPage;
